import { Directive } from "../Directive.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { ReactionType } from "../../ReactionType.js";


/**
 * A directive for showing a reaction.
 */
export class ReactionDirective extends Directive {
    readonly player: PlayerType | null;
    readonly reaction: ReactionType | null;

    constructor(
        directiveID: number,
        player: PlayerType | null,
        reaction: ReactionType | null,
    ) {
        super(directiveID);
        this.player = player;
        this.reaction = reaction;
    }

    isLimboDirective(): boolean {
        return this.reaction === null;
    }

    getPlayer(): PlayerType | null {
        return this.player;
    }

    getReaction(): ReactionType | null {
        return this.reaction;
    }
}
